import { Heading, Box, Flex } from '@chakra-ui/react';
import React from 'react';
import ReactMarkdown from 'react-markdown';

type Props = {
  title: string;
  description: string;
  children: React.ReactNode;
};

const SimpleCTA = ({ children, description, title }: Props) => (
  <Box textAlign="center">
    <Heading whiteSpace="pre-line" size="lg-md" mb={9} as="h2">
      {title}
    </Heading>
    <ReactMarkdown>{description}</ReactMarkdown>
    <Flex justify="center" align="center" mt={12}>
      {children}
    </Flex>
  </Box>
);

export default SimpleCTA;
